import { ActionHandler } from './action-handlers';
export const initialState = {
    name: 'Idle',
    contents: null,
    error: null
};
export const makeConfig = function(state = initialState, actions = ActionHandler) {
    const { addItems , changeQuantity , init , refresh , reload , removeItems , updateNote  } = actions;
    return {
        state,
        transitions: {
            Failure: {
                reload
            },
            Idle: {
                init
            },
            Initializing: {
                reload
            },
            Ready: {
                addItems,
                changeQuantity,
                refresh,
                reload,
                removeItems,
                updateNote
            },
            Refreshing: {
                reload
            },
            Stale: {
                refresh,
                reload
            },
            AddingItems: {
                reload
            },
            Updating: {
                reload
            }
        }
    };
};
